var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_31950",
    "data-name": "Group 31950",
    transform: "translate(18 18) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_853",
    "data-name": "Group 853",
    opacity: 0.003
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_347",
    "data-name": "Rectangle 347",
    width: 18,
    height: 18,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "upload",
    transform: "translate(17.012 17.037) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65938",
    "data-name": "Path 65938",
    d: "M8.913,2.9l.015,9.8h2l-.015-9.789,1.845,1.843,1.416-1.417L11.561.721a2.337,2.337,0,0,0-3.305,0L5.639,3.338,7.055,4.753Z",
    transform: "translate(-1.874)",
    fill: "#5076ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65939",
    "data-name": "Path 65939",
    d: "M14.021,16v3.338H2V16H0v3.338a2,2,0,0,0,2,2H14.021a2,2,0,0,0,2-2V16Z",
    transform: "translate(0 -5.305)",
    fill: "#5076ba"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.f2dad2b6b09eed168d1f99109e5a84fb.svg";
export { ForwardRef as ReactComponent };